import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {isNullOrUndefined} from "@qntm-code/utils";
import {EmployeeAppraisalLog, OrgAppraisalPeriod, QueryResult, SignedStatus} from '@app/shared';

@Injectable()
export class EmployeeAppraisalDataService {

  constructor(private http: HttpClient) {
  }

  getAppraisalsById(id: number) {
    return this.http.get(`/hr/appraisals/${id}`);
  }

  getSubordinateObsForSelf(): Observable<QueryResult> {
    return this.http.get<QueryResult>("/hr/subordinate-obs/self?start=0&count=-1");
  }

  getManagersList(appraisalPeriodId: number): Observable<any> {
    return this.http.get(`/hr/appraisals/managers?appraisalPeriodId=${appraisalPeriodId}`);
  }

  searchAppraisalPeriods(): Observable<any> {
    return this.http.get('/hr/appraisal-periods/search?start=0&count=-1');
  }

  saveOrUpdateAppraisalPeriod(appraisalPeriod: OrgAppraisalPeriod): Observable<any> {
    return this.http.post('/hr/appraisal-periods', appraisalPeriod);
  }

  searchAppraisalSummary(managerId: number, appraisalPeriodId: number, obsId: number, signedByUser?: SignedStatus): Observable<QueryResult> {
    let url = `/hr/appraisals/summary/search?start=0&count=-1`;
    if (managerId) {
      url += `&manager.id=${managerId}`;
    }
    if (appraisalPeriodId) {
      url += `&appraisalPeriod.id=${appraisalPeriodId}`;
    }
    if (obsId) {
      url += `&user.obs.id=${obsId}`;
    }
    if (!isNullOrUndefined(signedByUser) && signedByUser != SignedStatus.All) {
      url += `&signedByUser=${signedByUser == SignedStatus.Signed}`;
    }
    return this.http.get<QueryResult>(url);
  }

  searchAppraisal(managerId: number, periodId: number, obsId: number, signedByUser?: SignedStatus): Observable<any> {
    let url = `/hr/appraisals/search?start=0&count=-1`;
    if (managerId) {
      url += `&manager.id=${managerId}`;
    }
    if (periodId) {
      url += `&appraisalPeriod.id=${periodId}`;
    }
    if (obsId) {
      url += `&user.obs.id=${obsId}`;
    }
    if (!isNullOrUndefined(signedByUser) && signedByUser != SignedStatus.All) {
      url += `&signedByUser=${signedByUser == SignedStatus.Signed}`;
    }
    return this.http.get(url);
  }

  searchAppraisalLogs(appraisalId: number): Observable<QueryResult> {
    return this.http.get<QueryResult>(`/hr/appraisal-logs/search?appraisal.id=${appraisalId}`);
  }

  saveAppraisalLogs(log: EmployeeAppraisalLog): Observable<any> {
    return this.http.post('/hr/appraisal-logs', log);
  }

  closePeriod(appraisalId: number): Observable<any> {
    return this.http.post(`/hr/appraisal-periods/${appraisalId}?open=false`, '');
  }

  sendOverdueNotice(id: number): Observable<any> {
    return this.http.post(`/hr/appraisal-periods/${id}/notifications`, '');
  }

}
